import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { registerLicense } from '@syncfusion/ej2-base';

import { Buffer } from 'buffer';
import EventEmitter from 'events';
import process from 'process';

// sax.js needs these
(window as any).Buffer = Buffer;
(window as any).EventEmitter = EventEmitter;
(window as any).process = process;

registerLicense('Ngo9BigBOggjHTQxAR8/V1NNaF5cXmBCf1FpRmJGdld5fUVHYVZUTXxaS00DNHVRdkdmWXtfdHVVQ2hcUUBxWUJWYEo=');

bootstrapApplication(AppComponent, appConfig)
  .catch((err) => console.error(err));
